import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Bed, Building, User } from 'lucide-react';
import CamasSelector from './CamasSelector';

const GestionarCamasModal = ({ isOpen, onClose, hospedaje, onSave }) => {
  const [camas, setCamas] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen && hospedaje) {
      // Cargar camas existentes del hospedaje
      setCamas(hospedaje.camas || []);
    }
  }, [isOpen, hospedaje]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(hospedaje._id, camas);
      onClose();
    } catch (error) {
      console.error('Error al guardar camas:', error);
    } finally {
      setSaving(false);
    }
  };

  if (!hospedaje) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold flex items-center gap-2">
            <Bed className="h-6 w-6 text-purple-600" />
            Gestionar Camas del Activo
          </DialogTitle>
        </DialogHeader>

        {/* Información del hospedaje */}
        <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-2 border">
          <div className="flex items-center gap-2">
            <Building className="h-5 w-5 text-blue-600" />
            <div>
              <span className="font-semibold">Activo:</span>{' '}
              <span className="text-gray-700 dark:text-gray-300">{hospedaje.nombrePropiedad}</span>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <Building className="h-5 w-5 text-green-600" />
            <div>
              <span className="font-semibold">Portafolio:</span>{' '}
              <span className="text-gray-700 dark:text-gray-300">
                {hospedaje.edificio?.nombre || 'N/A'}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <User className="h-5 w-5 text-orange-600" />
            <div>
              <span className="font-semibold">Coordinador:</span>{' '}
              <span className="text-gray-700 dark:text-gray-300">
                {hospedaje.coordinador?.nombre || 'N/A'}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mt-2 pt-2 border-t">
            <div>
              <span className="font-semibold">Tipo:</span>{' '}
              <span className="text-gray-700 dark:text-gray-300 capitalize">{hospedaje.tipo}</span>
            </div>
            <div>
              <span className="font-semibold">Habitaciones:</span>{' '}
              <span className="text-gray-700 dark:text-gray-300">{hospedaje.numeroHabitaciones}</span>
            </div>
          </div>
        </div>

        {/* Selector de camas */}
        <div className="mt-4">
          <CamasSelector
            value={camas}
            onChange={setCamas}
            disabled={false}
          />
        </div>

        <DialogFooter className="mt-6">
          <Button variant="outline" onClick={onClose} disabled={saving}>
            Cancelar
          </Button>
          <Button 
            onClick={handleSave} 
            className="bg-purple-600 hover:bg-purple-700"
            disabled={saving}
          >
            <Bed className="h-4 w-4 mr-2" />
            {saving ? 'Guardando...' : 'Guardar Camas'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default GestionarCamasModal;
